import { SxProps, Theme } from '@mui/material'

export function flatSx(...sxArray: Array<SxProps<Theme> | undefined>): SxProps<Theme> {
    return sxArray
        .filter((it) => !!it) // filter undefined
        .flatMap((sx) => (Array.isArray(sx) ? sx : [sx ?? false]))
        .filter((it) => it !== false)
}
